<template>
  <vi-page>
    <template v-if="currentUser.role && currentUser.role.type === 'Casual'">
      <AgentCtrl></AgentCtrl>
    </template>
    <template v-if="currentUser.role && currentUser.role.type === 'Customer'">
      <CustomerCtrl @e-dialog="eDialog"></CustomerCtrl>
    </template>
    <vi-dialog
      :backdrop="true"
      :scrollable="true"
      v-if="modalNoticeData.addable && currentUser.role.type === 'Customer'"
      v-model="modalNoticeData.showAdd"
      :title="modalNoticeData.title"
      size="lg"
      @e-close="eCloseDialog"
      :footer="true"
      class="dialog_relative"
    >
      <div class="dialog_prev" v-if="slide != 0" @click="eNext(0)">
        <vi-icon name="fas:chevron-left" size="50px"></vi-icon>
      </div>
      <div class="dialog_next" v-if="slide != 1" @click="eNext(1)">
        <vi-icon name="fas:chevron-right" size="50px"></vi-icon>
      </div>
      <div v-if="slide == 0">
        <div class="carousel_box">
          <div class="">
            <div class="mt-2">根据业务需要，现将购买云产品下单流程进行优化：</div>
            <div class="mt-2">1.您在阿里云控制台购买好产品后,形成新的订单;</div>
            <div class="mt-2" style="font-size: 14px; font-weight: 700">
              2.（新步骤）返回时云后台,在【我的订单-待确认】中对订单进行确认操作;
            </div>
            <div class="mt-2">3.等待订单支付完成;</div>
            <div class="mt-2">4.支付成功,等待云产品创建,下单完成。</div>
          </div>
          <div class="mt-4">下单流程图示如下：</div>
          <img src="../../assets/notice/notice1.png" width="100%" />
          <div
            style="font-size: 14px; font-weight: 700; display: flex; align-items: center"
            class="mt-4"
          >
            <vi-icon name="fas:circle" class="mr-2" size="10px"></vi-icon> 订单确认操作说明
          </div>
          <div class="textIndent mt-4">
            具体确认订单操作可查看以下操作，如有疑问，请及时联系管理人员，我们将为您进行解答，给您造成的不便请谅解。
          </div>
          <div style="font-size: 14px; font-weight: 700" class="mt-4">
            1.如何确认单条订单？
          </div>
          <div class="textIndent mt-4">
            点击菜单【费用中心-我的订单】，查看【待确认】订单，点击订单列表中右侧操作栏中的【确认订单】按钮，出现订单信息，核对无误后，点击【确认】，即可确认订单
          </div>
          <img src="../../assets/notice/notice2.png" width="100%" class="mt-4" />
          <div class="mt-4">核对无误后，点击确认按钮</div>
          <img src="../../assets/notice/notice3.png" width="100%" class="mt-4" />
          <div style="font-size: 14px; font-weight: 700" class="mt-4">
            2.如何确认多条订单？
          </div>
          <div class="textIndent mt-4">
            点击菜单【费用中心-我的订单】，查看【待确认】订单，在订单列表左侧【勾选/全选】需要确认的订单，勾选完毕点击列表下方【批量确认订单】按钮，出现订单信息，核对无误后，点击【确认】，即可确认订单
          </div>
          <img src="../../assets/notice/notice4.png" width="100%" class="mt-4" />
          <div class="mt-4">核对无误后，点击确认按钮</div>
          <img src="../../assets/notice/notice5.png" width="100%" class="mt-4" />
        </div>
      </div>
      <div v-if="slide == 1">
        <div class="carousel_box">
          <div class="">
            在续费管理功能中，您可以对云产品进行“自动续费”、“手动续费”、“不续费”设置。该续费设置操作将调用阿里云API同步至阿里云平台，若操作失败或有疑问，请及时联系您所属的销售经理，我们将为您解决和解答。
          </div>
          <div class="mt-4">注意：本功能不提供续费操作，续费操作按现有业务模式进行。</div>
          <div style="font-size: 14px; font-weight: 700;display: flex; align-items: center" class="mt-4">
            <vi-icon name="fas:circle" class="mr-2" size="10px"></vi-icon> 续费管理操作说明
          </div>
          <div style="font-size: 14px; font-weight: 600" class="mt-4">
            1.设置单个资源续费设置
          </div>
          <div class="textIndent mt-4">
            点击菜单【费用中心-续费管理】，查看云资源列表，点击切换云资源续费类型区域按钮（自动续费、手动续费、到期不续费），可对云资源进行续费设置：开通/修改自动续费、不续费、恢复手动续费
            
          </div>
          <div class="mt-4">
            云资源续费类型查看切换
          </div>
          <img src="../../assets/notice/notice6.png" width="100%" class="mt-4" />
          <div class="mt-4">
            续费设置操作按钮，可针对指定云资源进行开通/修改自动续费、不续费、恢复手动续费设置
          </div>
          <img src="../../assets/notice/notice7.png" width="100%" class="mt-4" />
          <div class="mt-4">以修改自动续费设置为例，选择续费周期后，点击确认按钮即可</div>
          <img src="../../assets/notice/notice8.png" width="100%" class="mt-4" />
          <div class="mt-4">
            批量操作续费设置，先勾选需要设置的云资源，然后点击批量设置按钮，在弹出的对话框中完成操作即可。
          </div>
          <img src="../../assets/notice/notice9.png" width="100%" class="mt-4" />
        </div>
      </div>
    </vi-dialog>
  </vi-page>
</template>
<script>
import CustomerCtrl from "../../controls/overview/CustomerCtrl";
import AgentCtrl from "../../controls/overview/AgentCtrl";
import { mapGetters } from "vuex";
export default {
  name: "DashboardOverview",
  components: {
    CustomerCtrl,
    AgentCtrl,
  },
  data() {
    return {
      modalNoticeData: {
        addable: false,
        showAdd: false,
        title: "订单流程改变",
      },
      slide: 0,
      sliding: null,
      prevBg: false,
      nextBg: false,
    };
  },
  filters: {
    amountFromat(val) {
      if (val) {
        if (String(val) === "0") {
          return "0.00";
        }
        let numb = val.toFixed(5);
        let newStr = numb.split("");
        let index = newStr.indexOf(".") + 3;
        newStr.splice(index);
        let value = newStr.join("");
        return value;
      }
      return "0.00";
      // return val ? val.toFixed(5) : "0.00";
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  mounted() {
    let bool = window.localStorage.getItem("NoticeDialog");
    if (bool) {
      this.modalNoticeData.addable = false;
      this.modalNoticeData.showAdd = false;
    } else {
      this.modalNoticeData.addable = true;
      this.modalNoticeData.showAdd = true;
      window.localStorage.setItem("NoticeDialog", "11");
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
      this.modalNoticeData.title = "订单流程改变";
    },
    onSlideEnd(slide) {
      this.sliding = false;
      this.modalNoticeData.title = "新增续费管理";
    },
    eDialog(data) {
      this.modalNoticeData.addable = true;
      this.modalNoticeData.showAdd = true;
      if (data == 0) {
        this.modalNoticeData.title = "订单流程改变";
      }
      if (data == 1) {
        this.modalNoticeData.title = "新增续费管理";
      }
      this.slide = data;
    },
    eCloseDialog() {
      this.modalNoticeData.addable = false;
      this.modalNoticeData.showAdd = false;
    },
    eNext(val) {
      this.slide = val;
      if (val == 0) {
        this.modalNoticeData.title = "订单流程改变";
      }
      if (val == 1) {
        this.modalNoticeData.title = "新增续费管理";
      }
    },
  },
};
</script>
<style lang="scss">
.textIndent {
  text-indent: 2em;
}
.carousel-control-next-icon {
  width: 0;
  height: 0;
  display: inline-block;
  border-top: 25px solid transparent;
  border-bottom: 25px solid transparent;
  border-left: 27px solid #000;
  margin-left: 50px;
}
.carousel-control-prev-icon {
  width: 0;
  height: 0;
  display: inline-block;
  border-top: 25px solid transparent;
  border-bottom: 25px solid transparent;
  border-right: 27px solid #000;
  margin-right: 50px;
}
.carousel_box {
  background: #fff;
  padding: 0px 25px;
  i {
    color: #000;
  }
}

.dialog_prev {
  --button-color: var(--fa-gravy);
  position: fixed;
  top: 45%;
  left: 500px;
  --button-background: transparent;
  cursor: pointer;
  i {
    color: #000;
  }
}
.dialog_next {
  --button-color: var(--fa-gravy);
  position: fixed;
  top: 45%;
  right: 500px;
  --button-background: transparent;
  cursor: pointer;
  i {
    color: #000;
  }
}
.dialog_next:hover,
.dialog_prev:hover {
  i {
    color: gray;
  }
}
</style>
